import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { ProfileFiltersComponent } from '../../search-input/profile-filters/profile-filters.component';
import { selectSearchProfileDefault } from '../../search-state/search-profile.selectors';
import { selectSearchResultTerm } from '../../search-state/search-result.selectors';

@Component({
  standalone: false,
    selector: 'app-no-hits',
    templateUrl: './no-hits.component.html',
    styleUrls: ['./no-hits.component.scss'],
})
export class NoHitsComponent {
    searchTerm$: Observable<string | null | undefined>;
    areProfileFiltersSet$: Observable<boolean | undefined>;

    constructor(private readonly store: Store, private readonly dialogService: DialogService) {
        this.searchTerm$ = this.store.select(selectSearchResultTerm);
        this.areProfileFiltersSet$ = this.store.select(selectSearchProfileDefault);
    }

    openProfileFiltersDialog(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.dialogService.open(ProfileFiltersComponent, {
            showHeader: false,
            closeOnEscape: true,
            modal: true,
            dismissableMask: true,
            closable: true,
            focusOnShow: false,
            styleClass: 'profile-dialog',
            data: { title: 'Sucheinstellungen' },
        });
    }
}
